import React from 'react';

const ScrollableButtons = ({itemCount, itemIndex, onChangeItem, pages, page, firstPage, lastPage, onChangePage, values=10}) => (
    <div className="ui right floated pagination menu">

        {
            page <= firstPage ? (
                    <a className="icon item disabled">
                        <i className="angle double left icon"></i>
                    </a>) : (<a className="icon item" onClick={() => onChangePage('P')}>
                    <i className="angle double left icon"></i>
                </a>)
        }

        {
            itemIndex <= 0 ? (
                <a className="icon item disabled">
                    <i className="angle left icon"></i>
                </a>) : (<a className="icon item" onClick={() => onChangeItem('P')}>
                <i className="angle left icon"></i>
            </a>)
        }

        {
            itemIndex >= (itemCount-1) ? (
                <a className="icon item disabled">
                    <i className="angle right icon"></i>
                </a>
            ):(
                <a className="icon item" onClick={() => onChangeItem('N')}>
                    <i className="angle right icon"></i>
                </a>
            )
        }

        {
            page >= lastPage ? (
                    <a className="icon item disabled">
                        <i className="angle double right icon"></i>
                    </a>
                ):(
                    <a className="icon item" onClick={() => onChangePage('N')}>
                        <i className="angle double right icon"></i>
                    </a>
                )
        }
    </div>
)

export default ScrollableButtons


/** WEBPACK FOOTER **
 ** ./src/components/ScrollableButtons.jsx
 **/